module.exports = __webpack_public_path__ + "img/undo.55f7a495.svg";